module.exports = __webpack_public_path__ + "img/emoji_3.a6d86ef3.png";